import { Routes } from '@angular/router';
import { DeniedDrawingsComponent } from './denied-drawings/denied-drawings.component';
import { AllowListComponent } from './allow-list/allow-list.component';
import { DrawingStreamComponent } from './pages/drawing-stream/drawing-stream.component';
import { AuthGuard } from './auth.guard';
import { LoginComponent } from './login/login.component';
import { AuthCallbackComponent } from './login/auth-callback.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { StreamerViewComponent } from './streamer-view/streamer-view.component';
import { DatabaseAdminComponent } from './database-admin/database-admin.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'auth-callback', component: AuthCallbackComponent },
    { path: 'forbidden', component: ForbiddenComponent },
    {
        path: '',
        redirectTo: '/drawing-queue',
        pathMatch: 'full'
    },
    {
        title: 'Drawing Queue',
        path: 'drawing-queue',
        loadChildren: () => import('./drawing-queue/drawing-queue.module').then(m => m.DrawingQueueModule),
        canActivate: [AuthGuard]
    },
    {
        title: 'Denied Drawings',
        path: 'denied-drawings',
        component: DeniedDrawingsComponent,
        canActivate: [AuthGuard]
        // loadChildren: () => import('./denied-drawings/denied-drawings.module').then(m => m.DeniedDrawingsModule)
    },
    {
        title: 'Allow List',
        path: 'allow-list',
        component: AllowListComponent,
        canActivate: [AuthGuard]
        // loadChildren: () => import('./allow-list/allow-list.module').then(m => m.AllowListModule)
    },
    {
        title: 'Database Admin',
        path: 'database-admin',
        component: DatabaseAdminComponent,
        canActivate: [AuthGuard]
    },
    { path: 'drawing-stream', component: DrawingStreamComponent, canActivate: [AuthGuard] },
    {
        title: 'Streamer View',
        path: 'streamer-view',
        component: StreamerViewComponent
    },
];
